module.exports = __webpack_public_path__ + "img/dragon-quest-xi.31bafbe2.png";